<template>
	<v-container fluid class="pa-0 fill-height" style="display:flex; flex-grow: 1;">
		<div v-if="loading" class="d-flex flex-column align-center justify-center" style="width: 100%">
			<v-progress-circular
				:size="50"
				:width="2"
				color="#2D4B95"
				indeterminate
			></v-progress-circular>
			<div class="mt-4">Cargando Archivo</div>
		</div>
		<v-card v-else-if="item" class="fm-document-viewer pa-0 fill-height">
			<div class="d-flex align-center justify-space-between fm-document-header">
				<img :src="require('@/assets/Svg/logoWhite.svg')" style="max-width: 110px; width: 100%;"/>
				<div class="d-flex align-center">
					<v-icon class="mr-3" color="white">{{ getFileIcon }}</v-icon>
					<div class="font-weight-medium text-truncate">{{ item.name }}</div>
				</div>
				<div class="d-flex align-center" style="gap: 8px;">
					<v-chip small outlined color="white" label>{{ getFileInfo }}</v-chip>
					<div v-if="openMorphableText && fromInternalView">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									small
									color="white"
									@click="$emit('open-morphable', item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>{{ openMorphableIcon }}</v-icon>
								</v-btn>
							</template>
							<span>{{ openMorphableText }}</span>
						</v-tooltip>
					</div>
					<div>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									small
									:href="item.pathmedia?.path"
									target="_blank"
									color="white"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-download</v-icon>
								</v-btn>
							</template>
							<span>Descargar archivo</span>
						</v-tooltip>
					</div>
					<v-btn icon small @click="minimizeItem" class="ml-1" color="white" v-if="fromInternalView">
						<v-icon>mdi-minus</v-icon>
					</v-btn>
					<v-btn icon small @click="closeDialog" class="ml-1" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
			</div>
			<v-card-text class="fm-document-content pa-0">
				<div class="mlb-media-wrap">
					<!-- Image -->
					<img
						v-if="isImage"
						:src="mediaUrl"
						class="mlb-media mlb-img"
						:alt="item.name"
						draggable="false"
					/>
					<!-- Video -->
					<video
						v-else-if="isVideo"
						:src="mediaUrl"
						class="mlb-media mlb-video"
						controls
						playsinline
					/>
					<!-- Fallback -->
					<div v-else class="mlb-unsupported">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
							<circle cx="12" cy="12" r="10"/>
							<line x1="12" y1="8" x2="12" y2="12"/>
							<line x1="12" y1="16" x2="12.01" y2="16"/>
						</svg>
						<p>Formato no soportado</p>
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import { getFile } from '@/helpers/api/files'

export default {
  name: 'StandaloneMediaViewer',
  props: {
    itemProp: {
      type: Object,
      default: null
    },
		fromInternalView: {
			type: Boolean,
			default: false
		}
  },
  data() {
    return {
      loadFailed: false,
      isOpen: false,
			item_id: null,
			item: null,
			loading: true
    }
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.isOpen = true
      }
    }
  },
  computed: {
    mediaUrl() {
      return this.item?.pathmedia?.path || null
    },
    isImage() {
      if (!this.item || !this.mediaUrl) return false
      const ext = this.item.ext?.toLowerCase()
      return /^(jpe?g|png|gif|webp|avif|svg|bmp)$/i.test(ext)
    },
    isVideo() {
      if (!this.item || !this.mediaUrl) return false
      const ext = this.item.ext?.toLowerCase()
      return /^(mp4|webm|ogg|ogv|mov|m4v)$/i.test(ext)
    },
    getFileIcon() {
      if (this.isImage) return 'mdi-image'
      if (this.isVideo) return 'mdi-video'
      return 'mdi-file'
    },
    getFileInfo() {
      const ext = this.item?.ext?.toUpperCase() || 'ARCHIVO'
      const size = this.getFileSize()
      return `${ext}${size ? ` • ${size}` : ''}`
    },
		openMorphableText(){
			if(!this.item || !this.item.morphable_type) return null
			if(this.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'Abrir Tarea Asociada'
			}
			else if(this.item.morphable_type === 'App\\Models\\Rdi' || this.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'Abrir RDI Asociada'
			}
			else if(this.item.morphable_type === 'App\\Models\\Additional' || this.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'Abrir Adicional Asociado'
			}
			return null
		},
		openMorphableIcon(){
			if(!this.item || !this.item.morphable_type) return null
			if(this.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'mdi-clipboard-text-outline'
			}
			else if(this.item.morphable_type === 'App\\Models\\Rdi' || this.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'mdi-file-document-multiple-outline'
			}
			else if(this.item.morphable_type === 'App\\Models\\Additional' || this.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'mdi-notebook-plus-outline'
			}
			return null
		}
  },
	mounted() {
		if (this.itemProp) {
			this.item = this.itemProp
			this.loading = false
			return
		}

		this.item_id = this.$route.query?.item_id || this.$route.params?.item
		if(this.item_id){
			this.getItem()
		}
	},
  methods: {
		async getItem() {
			this.loading = true
			const file = await getFile({ file_id: this.item_id })
			if(file.code == 200){
				this.item = file.data
			} else {
				this.loadFailed = true
			}
			this.loading = false
		},

		minimizeItem() {
			this.$store.globalStore.commit('addFileToFileManagerHandler', this.item)
			this.closeDialog()
		},

    closeDialog() {
      this.isOpen = false
      this.$emit('close')
			window.close()
    },

    getFileSize() {
      const size = this.item?.size
      if (!size) return null
      if (size < 1024) return `${size} B`
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
      return `${(size / (1024 * 1024)).toFixed(2)} MB`
    }
  }
}
</script>

<style scoped>
.fm-document-viewer {
  display: flex;
  flex-direction: column;
  height: 100vh;
	width: 100vw;
	max-height: 100vh;
	max-width: 100vw;
}

.fm-document-header {
  border-bottom: 1px solid #213872;
  padding: 8px 16px !important;
  background: #2D4B95;
	color: white;
}

.fm-document-header .v-toolbar__content {
  padding: 0 !important;
}

.fm-document-content {
  flex: 1;
  overflow-y: auto;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.mlb-media-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.mlb-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 2px;
  box-shadow: 0 8px 48px rgba(0,0,0,0.3);
}

.mlb-img { 
  display: block;
}

.mlb-video { 
  width: 100%; 
  max-height: 100%; 
  background: #000;
}

.mlb-unsupported {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: rgba(0,0,0,0.4);
}

.mlb-unsupported svg { 
  width: 48px; 
  height: 48px;
}

.mlb-unsupported p { 
  font-size: 14px; 
  margin: 0;
}
</style>
